import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SortIcon = (props: IconProps) => (
  <Icon height="20px" width="20px" viewBox="0 0 20 20" {...props}>
    <path d="M2.5 15H7.5V13.3333H2.5V15ZM2.5 5V6.66667H17.5V5H2.5ZM2.5 10.8333H12.5V9.16667H2.5V10.8333Z" />
  </Icon>
);

export default memo(SortIcon);
